"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOverlayComponent = exports.createReactComponent = void 0;
var createComponent_1 = require("./createComponent");
Object.defineProperty(exports, "createReactComponent", { enumerable: true, get: function () { return createComponent_1.createReactComponent; } });
var createOverlayComponent_1 = require("./createOverlayComponent");
Object.defineProperty(exports, "createOverlayComponent", { enumerable: true, get: function () { return createOverlayComponent_1.createOverlayComponent; } });
//# sourceMappingURL=index.js.map